import { defaultChildrenThemes, adjustPalettes } from "./v5-themes";
var v5SubtlePaletteAdjustments = {
  default: {
    light: function(hsl) {
      return {
        ...hsl,
        s: hsl.s * 0.9
      };
    },
    dark: function(hsl, i) {
      return {
        ...hsl,
        s: hsl.s * (i <= 4 ? 0.7 : 0.9)
      };
    }
  },
  // yellow palette in radix is especially off from the rest
  yellow: {
    light: function(hsl, i) {
      var t = (i - 1) / 11;
      var sStart = 0.65;
      var sEnd = 0.4;
      var lStart = 1.08;
      var lEnd = 0.8;
      return {
        ...hsl,
        s: hsl.s * (sStart + t * (sEnd - sStart)),
        l: hsl.l * (lStart + t * (lEnd - lStart))
      };
    },
    dark: function(hsl, i) {
      return {
        ...hsl,
        s: hsl.s * (i <= 7 ? 0.45 : 0.55),
        l: hsl.l * (i <= 4 ? 0.8 : 1)
      };
    }
  }
};
var subtleChildrenThemes = adjustPalettes(defaultChildrenThemes, {
  ...v5SubtlePaletteAdjustments,
  gray: void 0,
  // skip
  neutral: void 0
});
export {
  subtleChildrenThemes,
  v5SubtlePaletteAdjustments
};
//# sourceMappingURL=subtleChildrenThemes.js.map
